export enum CheckedState {
    Unchecked,
    Checked,
    Indeterminate
}
